// Keep the daily card's visible leaderboard aligned with its top-five design.
export const DAILY_SHARE_REWARDS_SHARER_LIMIT = 5
